import CubDataFieldArray from 'components/fields/CubDataFieldArray';
import React, { Component } from 'react';
import { cubFunction } from '../../../constants/ListConstants';
import { Band, ToggleButton } from '../../../components/layout';
import {
  Container,
  Row,
  Col,
  Label,
  Collapse,
  FormGroup,
  Button
} from 'reactstrap';
import JobReferenceFieldArray from 'components/fields/JobReferenceFieldArray';
import { isVerified } from '../../../util/JobStateHelper';
import { connect } from 'react-redux';
import {
  getCubVentingRecord,
  createNewCubVenting,
  updateCubVenting,
  getInProgressJobs
} from 'api/operationsApi';
import { count } from 'rxjs-compat/operator/count';
import { isImportOrExportContainerAndMethylBromide } from 'util/JobTypeHelper';

class CubVentingSection extends Component {

  state = {
    collapsed: isVerified(this.props.currentState)
      ? false
      : this.props.complete,

    jobreferencelist: [],
    cubdetaillist: [],

    selectedJobs: [],
    selectedCubs: [],

    id: "",
    availableJobNumbers: [],
    notes: "",

    // This is what JobCompletion can use
    cubVentingComplete: false,
      // GPS location
  latitude: null,
  longitude: null,
  locationError: null,
  treatmentrecordcount:0,
  };

  toggleExpand = () => {
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed,
    }));
  };

  componentDidMount() {
    const { currentJob } = this.props;
    const jobReference = currentJob?.jobReference;
    console.log('stateCount',this.state.treatmentrecordcount)
    if(this.state.treatmentrecordcount === 0){
      var count = currentJob.treatmentResultRecords.length
      this.setState({treatmentrecordcount:count})
    }
 // Start GPS tracking
 // this.startLocationTracking();
    if (jobReference) {
      this.getCubVentingDetails(jobReference);
      this.getSelectableJobs(currentJob.id);
    }
  }
/*
 startLocationTracking = () => {
  if (!navigator.geolocation) {
    this.setState({
      locationError: 'Location services are not supported by this device.'
    });
    return;
  }

  const getLocation = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        console.log(
          'GPS:',
          position.coords.latitude,
          position.coords.longitude,
          'accuracy:',
          position.coords.accuracy,
          'time:',
          new Date(position.timestamp)
        );

        this.setState({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          locationAccuracy: position.coords.accuracy,
          locationTimestamp: position.timestamp,
          locationError: null
        });
      },
      (error) => {
        console.error('GPS error:', error);
        this.setState({
          locationError: error.message
        });
      },
      {
        enableHighAccuracy: true,
        maximumAge: 0,
        timeout: 2000
      }
    );
  };

  // Get the first reading immediately
  getLocation();

  // Then request another reading every second
  this.locationTimer = setInterval(() => {
    getLocation();
  }, 1000);
};
*/
componentWillUnmount() {
 /* if (this.watchId) {
    navigator.geolocation.clearWatch(this.watchId);
  }*/
}


  getSelectableJobs(id) {
    getInProgressJobs(id)
      .then((result) => this.updateJobNumber(result));
  }

  updateJobNumber(jobNumbers) {
    console.log('selectableJobs',jobNumbers)
    this.setState({
      availableJobNumbers: jobNumbers
    });
  }

  getCubVentingDetails(jobreference) {
    getCubVentingRecord(jobreference)
      .then((result) => result.data)
      .then((result) => this.checkResult(result));
  }

  checkResult = (result) => {
    const { currentJob } = this.props;

    if (!result || result.length <= 0) {

      const currentJobDetails = {
        jobNumber: currentJob.jobReference,
        shortname: currentJob.type.name,
        treatmentrecordcount:currentJob.treatmentResultRecords.length
      };
 

      const jobReferences = [currentJobDetails];
           console.log('jobreferenceCubventing',jobReferences)

      this.setState({
        jobreferencelist: jobReferences,

        // Start with the current job selected
        selectedJobs: jobReferences,

        cubdetaillist: [],
        selectedCubs: [],
        id: "",
        notes: "",
     //   treatmentrecordcount:totalCount,
      }, this.notifyParent);

      return;
    }

    const jobReferences =
      JSON.parse(result[0].jobreferenceventingjson || "[]");

    const cubDetails =
      JSON.parse(result[0].cubdetailsventingjson || "[]");

    const selectedJobs = jobReferences;
    const selectedCubs = cubDetails;

    const cubVentingComplete =
      selectedJobs.length > 0 &&
      selectedCubs.length > 0;
      console.log('selectedJobs',selectedJobs)
      

    this.setState({
      jobreferencelist: jobReferences,
      cubdetaillist: cubDetails,

      // IMPORTANT:
      // Existing saved data is also considered selected
      selectedJobs: selectedJobs,
      selectedCubs: selectedCubs,

      id: result[0].id,
      notes: result[0].notes || "",

      cubVentingComplete: cubVentingComplete

    }, this.notifyParent);
  };

  handleJobsSave = (jobs) => {

    const selectedJobs = jobs || [];
           var {currentJob} = this.props
    var currentJobCount = currentJob.treatmentResultRecords.length;
   
    var totalCount = selectedJobs.reduce((sum,item) =>sum +(Number(item.treatmentrecordcount||currentJobCount)),0);
            this.setState({treatmentrecordcount:totalCount})
  
    this.setState({
      selectedJobs: selectedJobs,

    }, this.updateCompletionStatus);
  };

  handleCubsSave = (cubs) => {

    const selectedCubs = cubs || [];

    this.setState({
      selectedCubs: selectedCubs
    }, this.updateCompletionStatus);
  };

  updateCompletionStatus = () => {

    const {
      selectedJobs,
      selectedCubs
    } = this.state;

    const complete =
      selectedJobs.length > 0 &&
      selectedCubs.length > 0;

    this.setState({
      cubVentingComplete: complete
    }, this.notifyParent);
  };

  notifyParent = () => {

    const {
      cubVentingComplete,
      selectedJobs,
      selectedCubs,
      notes,
      id
    } = this.state;
   // console.log('notifyingparent')

    // Tell JobCompletion about the current status
    //if (this.props.onCubVentingChange) {
     /* this.props.cubVentingChange({
        selectedJobs: selectedJobs,
        selectedCubs: selectedCubs,
        notes:notes,
        id:id
        });*/
   // }
  };

  handleSave = () => {

    const {
      selectedJobs,
      selectedCubs,
      id,
      notes
    } = this.state;

    const { currentJob ,markingsSubmit} = this.props;

    // Don't allow save unless both have been selected
    if (
      selectedJobs.length === 0 ||
      selectedCubs.length === 0
    ) {
      return;
    }

    const cubVentingDetails = {
      jobreferenceventingjson: JSON.stringify(selectedJobs),
      cubdetailsventingjson: JSON.stringify(selectedCubs),
      notes: notes
    };

    this.setState({
      collapsed: true
    });
    let saveCubPromise;

    if (!id) {
//return saveCubVenting(cubVentingDetails)
      saveCubPromise = createNewCubVenting(cubVentingDetails)
        .then(() => {this.getCubVentingDetails(currentJob.jobReference);
        });
        if(typeof markingsSubmit === 'function'){
        return markingsSubmit();
        }
        return markingsSubmit
    }

    
//this.props.saveCubVenting(cubVentingDetails)
   saveCubPromise =  updateCubVenting({
      id: id,
      ...cubVentingDetails
    }).then(() => {
      this.getCubVentingDetails(currentJob.jobReference);
    });
    return saveCubPromise.then(()=> {if (markingsSubmit){return markingsSubmit()}return null})
  };

  render() {

    const {
      collapsed,
      selectedJobs,
      selectedCubs
    } = this.state;

    const {
      currentJob,
      referenceData,
      currentState
    } = this.props;

    const cubVentingComplete =
      selectedJobs.length > 0 &&
      selectedCubs.length > 0;

    return (
      <Band dark>

        <div className="form-section">

          <Container>

            <Row className="align-items-center">
              <h4>Cub Venting</h4>
            </Row>
            <Row>
              <h4>
             {/*this.state.latitude !== null &&
      this.state.longitude !== null && (
       <span
          className="ml-3"
          style={{
            fontSize: '20px',
            fontWeight: 'normal'
          }}
        >
          X: {this.state.longitude.toFixed(6)}
          {' '}
          Y: {this.state.latitude.toFixed(6)}
           {' '}
        ±{Math.round(this.state.locationAccuracy)}m
        </span>
      )*/}
      </h4>
            </Row>

            <Collapse isOpen={!collapsed}>

              <div>

                <CubDataFieldArray
                  cubFunction={cubFunction}
                  currentJob={currentJob}
                  cubInventory={referenceData.cubs}
                  cubDetails={this.state.cubdetaillist}
                  onSave={this.handleCubsSave}
                  currentState={currentState}
                />

                <JobReferenceFieldArray
                  currentJob={currentJob}
                  jobreferenceJson={this.state.availableJobNumbers}
                  jobnumbers={this.state.jobreferencelist}
                  currentState={currentState}
                  totalcount ={this.state.treatmentrecordcount}
                  onSave={this.handleJobsSave}
                />
                <Row>
                  <FormGroup className="col-md-12">


                    <Label>Notes</Label>

                    <Row>
                      <Col>

                        <textarea
                          value={this.state.notes || ""}
                          disabled={
                            currentState === 'verified' ||
                            currentState === 'certified' ||
                            currentState === 'failed' ||
                            currentState === 'cancelled'
                          }
                          onChange={(e) =>
                            this.setState({
                              notes: e.target.value
                            },this.notifyParent)
                          }
                          style={{ width: '80%' }}
                        />

                      </Col>
                    </Row>

                  </FormGroup>

                </Row>

              </div>

              <Row>

                <FormGroup className="col-md-4">

                  <Button
                    type="button"
                    color="primary"
                    className="mt-3"
                    disabled={!cubVentingComplete}
                    onClick={this.handleSave}
                  >
                   {isImportOrExportContainerAndMethylBromide(currentJob.type, currentJob.treatmentTypeDetails.treatmentId)? "Save Cub Details" : "Save Markings & Cub Details"}
                  </Button>

                </FormGroup>

              </Row>

            </Collapse>

            <Row>

              <Col xs="12" className="text-right">

                <ToggleButton
                  color="light"
                  active={Boolean(collapsed)}
                  onClick={this.toggleExpand}
                  ligature="expand_less"
                />

              </Col>

            </Row>

          </Container>

        </div>

      </Band>
    );
  }
}

const mapStateToProps = (state) => ({
  referenceData: state.referenceData
});

export default connect(mapStateToProps)(CubVentingSection);